import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Footer from "../Footer";
import BottomBarIcons from "../BottomBarIcons";
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import {
  GET_ALL_INSPECTION_MASTER,
  DELETE_PROPERTY_INSPECTION,
} from "../../api/apiPath";
// import { hostName } from "../../config/config";

import Header from "../Header";
import Sidebar from "../Sidebar";
import NewDynamicTable from "../common/NewDynamicTable";
import Toaster from "../common/Toaster";
import ConfirmationPopup from "../common/ConfirmationPopup";
import InspectionTile from "./InspectionTile";
import { Statuses } from "../common/constant";

import { Box } from "@mui/material";
// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SidebarIcons from "../SidebarIcons";
import FilterSection from "../common/FilterSection";
import StatusPill from "../common/StatusPill";

import activeSchduleIcon from "../../assets/img/activeScheduleIcon.png";
import activeEditIcon from "../../assets/img/activeEditIcon.png";
import activeDeleteIcon from "../../assets/img/aciveDeleteIcon.png";
import activeHistoryIcon from "../../assets/img/activeHistoryIcon.png";
import disabledScheduleIcon from "../../assets/img/disabledScheduleIcon.png";
import disabledEditIcon from "../../assets/img/disabledEditIcon.png";
import disabledDeleteIcon from "../../assets/img/disabledDeleteIcon.png";
// import disabledHistoryIcon from "../../assets/img/activeScheduleIcon.png";



// import HistoryIcon from '@mui/icons-material/History';
// import { InputAdornment, TextField } from "@mui/material";
// import { sampleInspectorRows } from "../common/constant";

const Inspections = () => {
  const { clientNameParam } = useParams();
  const { userObj } = useSelector((state) => state.user);
  const [allPropertyList, setAllPropertyList] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState({});
  const navigate = useNavigate();
  const [toolbar, setToolBar] = useState({
    searchText: "",
    propertyName: "Property Name",
    inspector: "Inspector",
    status: "Status",
  });

 


  const [dateRange, setDateRange] = useState([null, null]);
  const [inspectorOptions, setInspectorOptions] = useState([]);

 const isAnyFilterApplied =
  toolbar.searchText !== "" ||
  toolbar.propertyName !== "Property Name" ||
  toolbar.inspector !== "Inspector" ||
  dateRange[0] !== null ||
  dateRange[1] !== null ||
  toolbar.status !== "Status";
  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  const closePopup = () => {
    setShowConfirmationPopup(false);
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
      //setAllPropertyList(sampleInspectorRows);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientId
      );
      if (response.status === 200) {
        const tempArr = [];
        let tempInsp = [];
        response?.data.map((inspection) => {
          const inspectorsArr = inspection.assignedInspectors.map(
            (item) => item.inspectorName
          );
          const newObj = {
            id: inspection.inspectionMasterId,
            propertyMasterId: inspection.properties[0]?.propertyMasterId,
            propertyName: inspection.properties[0]?.propertyName,
            inspector: inspectorsArr.join(", "),
            date: new Date(inspection.approvalDueDate).toLocaleDateString(
              "en-GB"
            ),
            CreatedDate: new Date(inspection.createdDate).toLocaleDateString(
              "en-GB"
            ),
            status: inspection.status,
            inspectionMasterId: inspection.inspectionMasterId,
            inspectionRefNumber: inspection.inspectionReferenceNumber,
            inspectionDate: inspection.scheduledInspectionDate ? new Date(inspection.scheduledInspectionDate).toLocaleDateString("en-GB") : "N/A"
          };
          tempInsp = [...tempInsp, ...inspectorsArr];
          tempArr.push(newObj);
        });
        console.log("response.data", response.data, tempArr);
        setAllPropertyList(tempArr);
        // setInspectorOptions(tempInsp);
        const uniqueSortedInspectors = Array.from(
  new Set(tempInsp) // remove duplicates
).sort((a, b) => a.localeCompare(b)); // alphabetical sort

setInspectorOptions(uniqueSortedInspectors);

      }
    } catch (error) {
      return error;
    } finally {
      // setLoading(false);
    }
  };

  const openEditScreen = (inspectionMasterId) => {
    const pathTemplate = "/client/:clientNameParam/inspection/:inspectionMasterId";
        const params = {
          clientNameParam: clientNameParam,
          inspectionMasterId: inspectionMasterId,
        };
    
        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
  };
  const openScheduleScreen = (inspectionMasterId) => {
     const pathTemplate = "/client/:clientNameParam/scheduleInspection/:inspectionMasterId";
        const params = {
          clientNameParam: clientNameParam,
          inspectionMasterId: inspectionMasterId,
        };
    
        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
  };
  // const openScheduleInspectionRefNumberScreen = (inspectionRefNumber) => {
  //    const pathTemplate = "/client/:clientNameParam/Calendar/:inspectionRefNumber";
  //       const params = {
  //         clientNameParam: clientNameParam,
  //         inspectionRefNumber: inspectionRefNumber,
  //       };
    
  //       const fullPath = generatePath(pathTemplate, params);
  //       navigate(fullPath);
  // };
  const openAuditScreen = (inspectionMasterId,propertyMasterId) => {
     const pathTemplate = "/client/:clientNameParam/BookingHistory/:inspectionMasterId/:propertyMasterId";
        const params = {
          clientNameParam: clientNameParam,
          inspectionMasterId: inspectionMasterId,
          propertyMasterId: propertyMasterId
        };
    
        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
  };

  const handleDeleteinspection = async (inspectionMasterid) => {
    setButtonLoading(true);
    const payload = {
      inspectionIds: [inspectionMasterid],
      loggedInUserEmail: userObj?.userEmail,
    };
    // const params = new URLSearchParams();
    // payload.inspectionIds.forEach((id) => params.append("inspectionIds", id));
    // params.append("loggedInUserEmail", payload.loggedInUserEmail);

    // const queryString = params.toString();
    // console.log(queryString);
    // console.log(payload);
    try {
      //const response = await http.delete(DELETE_PROPERTY_INSPECTION, JSON.stringify(payload));
      //const response = await http.delete(DELETE_PROPERTY_INSPECTION + `?${query}`)
      const response = await http.delete(DELETE_PROPERTY_INSPECTION, {
        data: payload, // 👈 body goes in "data"
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Inspection has been deleted successfully.",
          });
        }, 1000);
        handleGetAllPropertyByClinetID(clientObj.clientId);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting inspection, please try again.",
          });
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setButtonLoading(false);
      setShowConfirmationPopup(false);
      setPropertyToDelete({});
    }
  };

  useEffect(() => {
    if (allPropertyList) {
      const tempfilteredRows = allPropertyList?.filter((row) => {
        const matchesSearch =
          !toolbar.searchText ||
          row.propertyName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.inspector
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.inspectionDate?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
          row.inspectionDate?.toLowerCase().includes(
            toolbar.searchText.toLowerCase()
          ) ||
          // row.inspectionMasterId == toolbar.searchText ||
          row.inspectionRefNumber
  ?.toLowerCase()
  .includes(toolbar.searchText.toLowerCase()) ||

          row.status?.toLowerCase().includes(toolbar.searchText.toLowerCase());

        const matchesPropertyName =
          toolbar.propertyName === "Property Name" ||
          row.propertyName.toLowerCase() === toolbar.propertyName.toLowerCase();

        const matchesInspector =
          toolbar.inspector === "Inspector" ||
          row.inspector
            ?.toLowerCase()
            .includes(toolbar.inspector.toLowerCase());

        const matchesStatus =
          toolbar.status === "Status" || row.status === toolbar.status;

        // const [day, month, year] = row.date.split("/");
        // const rowDate = stripTime(`${year}-${month}-${day}`);
        // const [day1, month1, year1] = row.CreatedDate.split("/");
        // const creRowDate = stripTime(`${year1}-${month1}-${day1}`);
        // const [start, end] = dateRange;

        // const matchesDate =
        //   start === null ||
        //   end === null ||
        //   ((!start || rowDate >= stripTime(start)) &&
        //     (!end || rowDate <= stripTime(end))) ||
        //   ((!start || creRowDate >= stripTime(start)) &&
        //     (!end || creRowDate <= stripTime(end)));
        const [start, end] = dateRange;
        let matchesDate = true; // Show all by default if no filter is set

        // 2. Only run logic if a Start Date is selected
        if (start) {
          // Check if the row has a valid Inspection Date (ignore N/A)
          if (row.inspectionDate && row.inspectionDate !== "N/A") {
            
            // Parse "DD/MM/YYYY" from row.inspectionDate
            const [d, m, y] = row.inspectionDate.split("/");
            
            // Create a comparable Date object (set time to midnight)
            // Note: Month is 0-indexed in JS Date (0 = Jan, 1 = Feb)
            const inspectionDate = new Date(y, m - 1, d);
            inspectionDate.setHours(0, 0, 0, 0);

            const startDate = new Date(start);
            startDate.setHours(0, 0, 0, 0);

            // 3. Define the Matching Logic
            if (!end) {
              // EXACT MATCH: If only one date is selected, show ONLY that date
              matchesDate = inspectionDate.getTime() === startDate.getTime();
            } else {
              // RANGE MATCH: If both dates are selected, show range
              const endDate = new Date(end);
              endDate.setHours(0, 0, 0, 0);
              matchesDate = inspectionDate >= startDate && inspectionDate <= endDate;
            }
          } else {
            // If filter is ON but row has "N/A", hide the row
            matchesDate = false;
          }
        }
        console.log(
          "date",
          dateRange,
          start,
          end,
          matchesDate,
        );

        return (
          matchesSearch &&
          matchesPropertyName &&
          matchesInspector &&
          matchesStatus &&
          matchesDate
        );
      });
      setFilteredRows(tempfilteredRows);
    } else {
      setFilteredRows(allPropertyList);
    }
  }, [allPropertyList, toolbar, dateRange]);
  // const stripTime = (date) => {
  //   const d = new Date(date);
  //   d.setHours(0, 0, 0, 0);
  //   return d;
  // };

  const tableColumns = [
    {
      field: "inspectionRefNumber",
      height: 50,
      width: 170,
      minWidth: 170,
      headerName: "Inspection Ref. No",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "propertyName",
      height: 50,
      width: 200,
      minWidth: 200,
      headerName: "Property Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "date",
      width: 160,
      height: 50,
      headerName: "Approval Due Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "inspectionDate",
      width: 150,
      height: 50,
      headerName: "Inspection Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "inspector",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Assigned Inspector(s)",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },

    {
      field: "status",
      headerName: "Status",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const status = params.value;
        return <StatusPill status={status} />;
        
      },
    },
    {
      field: "CreatedDate",
      width: 130,
      height: 50,
      headerName: "Created Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 130,
      flex: 1,
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 140,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 170,
      flex: 1,
      renderCell: (data) => {
        const isDisabled =
          data?.row?.status === Statuses.CANCELLED ? true : false;
        const isNew = data?.row?.status === Statuses.NEW || data?.row?.status === Statuses.SCHEDULED  ? true : false;
        const isCompleted = (data?.row?.status === Statuses.COMPLETED || data?.row?.status === Statuses.REJECTED) ? true : false;
        return (
          <Box >
            <img
              // disabled={isDisabled || isCompleted}
              tabIndex={0}
              alt="Edit Inspection"
              title="Edit Inspection"
              onClick={(isDisabled || isCompleted) ? () => {} : () => openEditScreen(data?.row?.inspectionMasterId)}
              src={(isDisabled || isCompleted) ? disabledEditIcon : activeEditIcon}
              style={(isDisabled || isCompleted) ? {cursor: 'inherit'} : {cursor: 'pointer'}}
            >
            </img>
            <img
              tabIndex={0}
              alt="Schedule Inspection"
              title="Schedule Inspection"
              onClick={(isDisabled || !isNew) ? () => {} : () => openScheduleScreen(data?.row?.inspectionMasterId)}
              src={(isDisabled || !isNew) ? disabledScheduleIcon : activeSchduleIcon}
              style={(isDisabled || !isNew) ? {cursor: 'inherit'} : {cursor: 'pointer'}}

            >
            </img>
            {/* <img
              tabIndex={0}
              alt="Schedule Inspection"
              title="Schedule Inspection"
              onClick={(isDisabled || !isNew) ? () => {} : () => openScheduleInspectionRefNumberScreen(data?.row?.inspectionRefNumber)}
              src={(isDisabled || !isNew) ? disabledScheduleIcon : activeSchduleIcon}
              style={(isDisabled || !isNew) ? {cursor: 'inherit'} : {cursor: 'pointer'}}

            /> */}
            <img
              disabled={isDisabled || isCompleted}
              tabIndex={0}
              title="Delete Inspection"
              alt="Delete Inspection"
              onClick={(isDisabled || isCompleted) ? () => {} : () => {
                setPropertyToDelete(data?.row);
                setShowConfirmationPopup(true);
              }}
              src={(isDisabled || isCompleted) ? disabledDeleteIcon : activeDeleteIcon}
              style={(isDisabled || isCompleted) ? {cursor: 'inherit'} : {cursor: 'pointer'}}

            >              
            </img>
               <img
              tabIndex={0}
              title="Booking History"
              alt="Booking History"
              onClick={() => openAuditScreen(data?.row?.inspectionRefNumber,data?.row?.propertyMasterId)}
              src={activeHistoryIcon}
              style={{cursor: 'pointer'}}
              >
            </img>
          </Box>
        );
      },
    },
  ];
const sortedStatusOptions = allPropertyList
  ? Array.from(
      new Set(allPropertyList.map((item) => item.status))
    ).sort((a, b) => a.localeCompare(b))
  : [];

  return (

    <>
    
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <ConfirmationPopup
        show={showConfirmationPopup}
        headingText="Delete Inspection"
        infoText={`Please confirm if you want to delete inspection for Property: ${propertyToDelete.propertyName}`}
        cancelText="Cancel"
        submitText={buttonLoading ? "Deleting..." : "Delete"}
        onCancel={() => {
          closePopup();
        }}
        onSubmit={() =>
          handleDeleteinspection(propertyToDelete.inspectionMasterId)
        }
      />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
           <SidebarIcons 
             setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
              />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="border-0 w-100">
              <div
                className="dashboard_header dashboard_header_inspection d-flex"
                style={{ textAlign: "justify" }} //marginTop: "37px" }}
              >
                <div>
                  <h2 className="mb-0">Property Inspections</h2>
                  <p className="header-description">
                    Manage and track all property inspections
                  </p>
                </div>
                <div className="col-md-4 col-12 new-inspection-btn">
                  <button
                    className="btn btn-primary custom_toolbar_btn"
                    onClick={() => navigate(
                            generatePath("/client/:clientNameParam/inspection", {
                              clientNameParam,
                            })
                    )}
                  >
                    <i
                      className="fa fa-solid fa-plus"
                      style={{ paddingRight: "0.3rem" }}
                    ></i>
                    New Inspection
                  </button>
                </div>
              </div>

              
              <FilterSection 
                setToolBar={setToolBar}
                toolbar={toolbar}
                dropdown1Value = {toolbar.inspector}
                handleDropdown1Change = {(e) => setToolBar({ ...toolbar, inspector: e.target.value })}
                dropdown1Options={inspectorOptions}
                dropdown1Text="Inspector"
                isdateRange={true}
                dateRange={dateRange}
                setDateRange={setDateRange}
                dropdown2Value = {toolbar.status}
                handleDropdown2Change = {(e) => setToolBar({ ...toolbar, status: e.target.value })}
                // dropdown2Options={allPropertyList?.map((user) => user.status)}
                dropdown2Options={sortedStatusOptions}

                dropdown2Text="Status"
                resetToolbar = {() => setToolBar({
                  searchText: "",
                  propertyName: "Property Name",
                  inspector: "Inspector",
                  status: "Status",
                })}
                isAnyFilterApplied={isAnyFilterApplied}
                button1Text="New Inspection"
                button1Path = "/client/:clientNameParam/inspection"
              />
              <div className="inspection-table">
                <NewDynamicTable
                  tableData={filteredRows}
                  columnsValue={tableColumns}
                  pageSize={10}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                />
              </div>
              <div className="inspection-tile">
                {filteredRows &&
                  filteredRows?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <InspectionTile
                        tableData={item}
                        openEditScreen={(itemid) => openEditScreen(itemid)}
                        openAuditScreen={(inspRef, propMaster) => openAuditScreen(inspRef, propMaster)}
                        openScheduleScreen={(itemid) =>
                          openScheduleScreen(itemid)
                        }
                        setPropertyToDelete={setPropertyToDelete}
                        setShowConfirmationPopup={setShowConfirmationPopup}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          <Footer />
<div className="bottom-bar-spacing"></div>
<BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default Inspections;
